import { Outlet } from 'react-router-dom'

const Campaign = () => <Outlet />

export default Campaign
